import i18n from "@/i18n";
import { cn } from "@/lib/cn";
import type { LiveLogTreeLogEntryRowProps } from "@/types/ui";
import * as styles from "./LiveLogTree.styles";

const LEVEL_COLORS: Record<string, string> = {
  INFO: "text-sky-400",
  WARN: "text-yellow-400",
  ERROR: "text-red-400",
  DEBUG: "text-purple-400",
};

const Timestamp = ({ ts }: { ts: string }) => {
  return <span className={styles.logEntryRowTimestamp}>{ts}</span>;
};

const LogEntryRow = ({ entry }: LiveLogTreeLogEntryRowProps) => {
  const displayMessage = entry.key ? i18n.t(`backendLogs:${entry.key}`, { ...entry.params }) : entry.message;

  return (
    <div className={styles.logEntryRow}>
      <span
        className={cn(
          "font-mono text-[8px] md:text-[9px] font-bold w-6 md:w-8 shrink-0 mt-0.5",
          LEVEL_COLORS[entry.level] ?? "text-muted-foreground",
        )}
      >
        {entry.level}
      </span>
      <Timestamp ts={entry.timestamp} />
      <span className={styles.logEntryRowMessage}>{displayMessage}</span>
    </div>
  );
};

export { LogEntryRow };
